import { render } from "./ClientShow.vue?vue&type=template&id=bc5ed4ca&scoped=true"
import script from "./ClientShow.vue?vue&type=script&lang=js"
export * from "./ClientShow.vue?vue&type=script&lang=js"

import "./ClientShow.vue?vue&type=style&index=0&id=bc5ed4ca&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc5ed4ca"]])

export default __exports__